import {Component, Input, OnInit} from '@angular/core';
import {DocumentosService} from "../../../../services/documentos.service";
import {DocumentosDescargaRequestDto} from "../../../../dto/expediente/documentos.dto";
import {Constants} from "../../../../constants/constants";

@Component({
  selector: 'app-documentos-supersociedades-insolvencia',
  templateUrl: './documentos-supersociedades-insolvencia.component.html',
  styleUrl: './documentos-supersociedades-insolvencia.component.scss'
})
export class DocumentosSupersociedadesInsolvenciaComponent implements OnInit{
  // ID expediente
  @Input() idExpediente!: number;
  // Listas
  documentos: any[] = [];
  constructor(
    private documentoService: DocumentosService
  ) {
  }
  ngOnInit(): void {
    // Se consume el servicio que obtiene los documentos por ID expediente
    this.documentoService.getListaDocumentosByExpediente(this.idExpediente).subscribe((resp: any) => {
      this.documentos = resp.data;
    });
  }

  descargar(idDocumento: number) {
    const dto: DocumentosDescargaRequestDto = {
      ids: [Number(idDocumento)],
      idEntidad: Constants.ID_ENTIDAD_SUPER_SOCIEDADES,
      expediente: Number(this.idExpediente)
    }
    this.documentoService.getDocumentosDescarga(dto, Number(this.idExpediente), (Constants.ID_ENTIDAD_SUPER_SOCIEDADES).toString());
  }
}
